<div class="service-definitions">
  <h2 class="mt-0 mb-0">{{ 'FEATURES.SERVICE_DEFINITION_CARDS.TITLE' | transloco }}</h2>
  <div class="description">{{ 'FEATURES.SERVICE_DEFINITION_CARDS.DESCRIPTION' | transloco }}</div>
  <div class="service-cards">
    <ng-container *ngIf="!loader; else skeletonCards">
    <button type="button" class="blueptints" *ngFor="let blueprint of blueprintCards" (click)="navigateToServiceDetails(blueprint)">
      <div class="card-header">
        <div class="service-icon" role="img" [attr.aria-label]="blueprint.name">
          <mat-icon svgIcon="building_columns" class="service-icon-glyph"></mat-icon>
        </div>
        <div class="instances-count" *ngIf="blueprint.instancesCount !== null; else instancesSkeleton">{{ blueprint.instancesCount }} {{ (blueprint.instancesCount === 1 ? 'FEATURES.SERVICE_DEFINITION_CARDS.ENVIRONMENT' : 'FEATURES.SERVICE_DEFINITION_CARDS.ENVIRONMENTS') | transloco }}</div>
        <ng-template #instancesSkeleton>
          <ngx-skeleton-loader class="block skeleton-instances-count" appearance="line"></ngx-skeleton-loader>
        </ng-template>
      </div>
      <div class="blueprint-name">{{ blueprint.name }}</div>
      <div class="solution-name">{{ blueprint.solutionName }}</div>
      <mat-divider class="card-divider"></mat-divider>
      <div class="card-footer">
        <mat-icon svgIcon="chevron_right" class="card-arrow"></mat-icon>
      </div>
    </button>
    </ng-container>
    <ng-template #skeletonCards>
      <div class="blueptints skeleton-card" *ngFor="let placeholder of skeletonItems">
        <div class="pl-6 skeleton-loader">
          <ngx-skeleton-loader count="3" appearance="line"></ngx-skeleton-loader>
        </div>
      </div>
    </ng-template>
  </div>
</div>
